import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { TeamReportPage } from '@/features/reports/team/team-report-page'
import { formatDocumentTitle } from '@/lib/document-title'

/** Reports › Team at `/$orgId/reports/team`, open to every report viewer. */
export const Route = createFileRoute('/_auth/$orgId/reports/team')({
  component: TeamRoute,
})

function TeamRoute() {
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Team')}</title>
      </Helmet>
      <TeamReportPage />
    </>
  )
}
